module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Live Run")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Monitor active sessions and open the next scheduled LiveRun races")])]), _vm._v(" "), _c('router-link', {
    staticClass: "lr-primary-btn",
    attrs: {
      "to": "/admin/races/add"
    }
  }, [_c('svg', {
    staticClass: "lr-btn-icon",
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14M5 12h14"
    }
  })]), _vm._v("\n      New Race\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "lr-summary-grid"
  }, [_c('div', {
    staticClass: "lr-summary-card"
  }, [_c('span', {
    staticClass: "lr-summary-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 7v5l3 2"
    }
  })])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "lr-summary-label"
  }, [_vm._v("In Progress")]), _vm._v(" "), _c('strong', {
    staticClass: "lr-summary-value"
  }, [_vm._v(_vm._s(_vm.racesInProgress.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "lr-summary-card"
  }, [_c('span', {
    staticClass: "lr-summary-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 2v4M8 2v4M3 10h18"
    }
  })])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "lr-summary-label"
  }, [_vm._v("To Start")]), _vm._v(" "), _c('strong', {
    staticClass: "lr-summary-value"
  }, [_vm._v(_vm._s(_vm.racesToStart.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "lr-summary-card"
  }, [_c('span', {
    staticClass: "lr-summary-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13M8 12h13M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01M3 12h.01M3 18h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "lr-summary-label"
  }, [_vm._v("Ready Queue")]), _vm._v(" "), _c('strong', {
    staticClass: "lr-summary-value"
  }, [_vm._v(_vm._s(_vm.totalLiveRaces))])])])]), _vm._v(" "), _c('div', {
    staticClass: "lr-list-stack"
  }, [_c('race-list', {
    attrs: {
      "subtitle": "In Progress",
      "description": "Live sessions that have started and are awaiting completion",
      "races": _vm.racesInProgress,
      "loading": _vm.isRacesLoading,
      "message-empty-list": "No races are currently in progress."
    },
    on: {
      "delete": _vm.handleDeleteRace
    }
  }), _vm._v(" "), _c('race-list', {
    attrs: {
      "subtitle": "To Start",
      "description": "Scheduled sessions ready for trainer launch",
      "races": _vm.racesToStart,
      "loading": _vm.isRacesLoading,
      "message-empty-list": "You don't have upcoming races."
    },
    on: {
      "delete": _vm.handleDeleteRace
    }
  })], 1), _vm._v(" "), (_vm.$isDevMode()) ? _c('div', {
    staticClass: "lr-dev-card lr-dev-card--bottom"
  }, [_c('div', {
    staticClass: "lr-dev-copy"
  }, [_c('strong', {
    staticClass: "lr-dev-title"
  }, [_vm._v("Development Tools")]), _vm._v(" "), _c('span', {
    staticClass: "lr-dev-subtitle"
  }, [_vm._v("Remove all visible active and upcoming races from this view.")])]), _vm._v(" "), _c('button', {
    staticClass: "lr-danger-btn",
    on: {
      "click": _vm.deleteAllRaces
    }
  }, [_c('svg', {
    staticClass: "lr-btn-icon",
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 6h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 11v6M14 11v6"
    }
  })]), _vm._v("\n      Delete All\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25e608aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/LiveRun.vue
// module id = 1684
// module chunks = 2